module.exports = __webpack_public_path__ + "img/api-management.42463c70.svg";